import _ from 'lodash';
import Config from '../../AppConfig';
import { get } from './core/fetch';

export const getOfficeUserEmulatedAdviserDetails = async (
	targetUserId: string
): Promise<any> => {
	const emulationUrl =
		`${Config.mlcApiPrefix}/identity/` +
		targetUserId.replace('#/', '') +
		'/delegate';
	return await get(emulationUrl, {
		withAuth: true,
		noGateway: false,
	});
};
